// removed by extract-text-webpack-plugin
module.exports = {"profile-badge":"profile-badge","small":"small","badge":"badge","__react_component_tooltip":"__react_component_tooltip","place-top":"place-top"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/ProfileBadge/ProfileBadge.scss
// module id = fuzy
// module chunks = 0